import { render } from "./TabsRadio.vue?vue&type=template&id=9c5f8ad8"
import script from "./TabsRadio.vue?vue&type=script&lang=js"
export * from "./TabsRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__